import { render, staticRenderFns } from "./ProductionOrder.vue?vue&type=template&id=c1f683a0&"
import script from "./ProductionOrder.vue?vue&type=script&lang=js&"
export * from "./ProductionOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports